import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MultiselectObjectManagerComponentBase } from '../../../core/component/multiselect-object-manager/multiselect-object-manager.component';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { LettingFeatureAdmin } from '../../model/letting-feature-admin';
import { lettingFeatureCommand } from '../../command/letting-feature-command';
import { DeleteLettingFeaturesCommandHandler } from '../../service/command/delete-letting-features-command-handler.service';
import { LettingFeatureCommandHandlerResolver } from '../../service/command/letting-feature-command-handler-resolver.service';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { LettingFeatureAdminService } from '../../service/data/letting-feature-admin.service';

@Component({
  selector: 'app-letting-feature-manager',
  templateUrl: './../../../core/component/multiselect-object-manager/multiselect-object-manager.template.html',
  styleUrls: ['./../../../core/component/multiselect-object-manager/multiselect-object-manager.component.scss'],
  providers: [DeleteLettingFeaturesCommandHandler, LettingFeatureCommandHandlerResolver],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LettingFeatureManagerComponent extends MultiselectObjectManagerComponentBase<LettingFeatureAdmin> {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    dataService: LettingFeatureAdminService,
    dispatcher: CommandDispatcher,
    messageService: MessageService,
    navigationService: NavigationService,
    handlerResolver: LettingFeatureCommandHandlerResolver
  ) {
    super(dataService, dispatcher, handlerResolver, messageService, navigationService);
    this.columnDefinition = columnDefinitionService.create('LettingFeatureAdmin');
    this.title = 'LETTING_FEATURE.LETTING_FEATURES';
    this.preferencesKey = 'rent.letting-feature.list';
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.addMultiselectMenuItem('DELETE_BTN', lettingFeatureCommand.deleteMany);
  }
}
